import {Tooltip} from "bootstrap";

export default function(root) {
	Array.from(root.querySelectorAll('[data-bs-toggle="tooltip"]'))
		.forEach(tooltipNode => {
			new Tooltip(tooltipNode)
		})
}
